import AddRequestInterceptor from './requestInterceptor'
import AddResponseInterceptor from './responseInterceptor'

export default function AxiosAuthentication ({ axios }) {
  AddRequestInterceptor({ axios })
  AddResponseInterceptor({ axios })
}
